import { BlankState, Flex, InPageMessaging, Section } from '@bamboohr/fabric';

type AccessDeniedPageProps = {
	subtitleText?: string;
}

export const AccessDeniedPage = ({ subtitleText }: AccessDeniedPageProps) => {
	return (
		<Flex flexDirection='column' gap={2.5} height='100%'>
			<InPageMessaging header={$.__('Access Denied')} type="error" />
			<Section height='100%'>
				<BlankState icon='bs-lock' subtitle={subtitleText ? $.__("It looks like you don't have access to this page. %1", subtitleText) : $.__("It looks like you don't have access to this page.")} title={$.__('Hold Up.')} />
			</Section>
		</Flex>
	)
}